<template>
  <el-tree
    :data="processNode"
    node-key="id"
    default-expand-all
    draggable
    :allow-drop="allowDrop"
    :allow-drag="allowDrag"
    @node-drag-start="handleDragStart"
  >
    <div slot-scope="{ node, data }">
      <div
        :class="[data.id === 'Gateway' ? 'gateway' : '', 'element-item']"
        :style="getElementStyle(data)"
      >
        <span>{{ data.label }}</span>
      </div>
    </div>
  </el-tree>
</template>

<script>
const processNode = [
  {
    id: "Approver",
    label: "审批",
    type: "bpmn:UserTask",
    icon: "el-icon-user-solid",
    backgroundColor: "#fff3ea",
    borderColor: "#e8cead"
  },
  {
    id: "Finance",
    label: "财务",
    type: "bpmn:UserTask",
    icon: "el-icon-s-finance",
    backgroundColor: "#e7f8ff",
    borderColor: "#5083b0"
  },
  {
    id: "Cashier",
    label: "出纳",
    type: "bpmn:UserTask",
    icon: "el-icon-s-data",
    backgroundColor: "#e7f8ff",
    borderColor: "#5083b0"
  },
  {
    id: "Copy",
    label: "抄送",
    type: "bpmn:ServiceTask",
    icon: "el-icon-s-order",
    backgroundColor: "#f9f1ff",
    borderColor: "#a590bb"
  },
  {
    id: "Gateway",
    label: "条件分支",
    type: "bpmn:ExclusiveGateway",
    icon: "el-icon-s-operation",
    backgroundColor: "#e9fffc",
    borderColor: "#a5dcd7"
  }
];
export default {
  data() {
    return {
      processNode: processNode,
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    getElementStyle(data) {
      return {
        backgroundColor: data.backgroundColor,
        border: `2px solid ${data.borderColor}`
      };
    },
    handleDragStart(node, ev) {
      window.draggingNode = node;
    },
    allowDrop(draggingNode, dropNode, type) {
      return false;
    },
    allowDrag(draggingNode) {
      return draggingNode.isLeaf;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/mixin.scss";

::v-deep .el-tree-node {
  $elementWidth: 80px;
  $gatewayWidth: 60px;
  $translate: calc(#{$gatewayWidth} / 4);

  margin: 50px auto;
  width: $elementWidth;

  .element-item {
    height: 55px;
    width: $elementWidth;
    border-radius: 10px;
    line-height: 55px;
    text-align: center;
    font-size: 14px;
  }

  &:nth-child(5) {
    width: calc(#{$gatewayWidth} * 1.4);
    height: calc(#{$gatewayWidth} * 1.4);

    .el-tree-node__content {
      width: $gatewayWidth;
      height: $gatewayWidth;
      transform: rotate(45deg) translateX(#{$translate});

      .gateway {
        height: $gatewayWidth;
        width: $gatewayWidth;
        line-height: $gatewayWidth;
        span {
          display: inline-block;
          transform: rotate(-45deg);
        }
      }
    }
  }
}

::v-deep .el-tree-node__content {
  height: 100%;
}
::v-deep .el-icon-caret-right {
  display: none;
}
</style>
